module.exports = __webpack_public_path__ + "img/monitorIcon.c1ef11c6.svg";